import { fun_PostAction, fun_Download } from "@/api";
import { fun_GetKeys } from "@/utils/validate";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        constructionNo: null, // 报建编号
        prjName: null, // 项目名称
        startDate: null, // 发布开始时间
        endDate: null, // 发布结束时间
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "报建编号：",
          value: "constructionNo",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "date",
          label: "发布开始时间：",
          dateType: "date",
          value: "startDate",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd",
        },
        {
          type: "date",
          label: "发布结束时间：",
          dateType: "date",
          value: "endDate",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd",
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "工程名称",
          slotName: "prjName",
          width: "380",
          fixed: true,
        },
        {
          label: "监管部门",
          prop: "regulatorsName",
          width: "300"
        },
        {
          label: "报建编号",
          prop: "constructionNo",
          width: "200"
        },
        {
          label: "建设单位",
          prop: "buildCorp",
          width: "280"
        },
        {
          label: "立项批准文号",
          prop: "noteNumber",
          width: "250"
        },
        {
          label: "施工单位",
          prop: "constructionUnitName",
          width: "280"
        },
        {
          label: "计划工期（日历天）",
          prop: "planTimeLimit",
          width: "170"
        },
        {
          label: "工程造价（万元）",
          prop: "projectCost",
          width: "150"
        },
        {
          label: "发布时间",
          prop: "sealDate",
          width: "180"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
      // 服务器时间
      serverTime: null
    };
  },
  // 注册组件
  components: {
  },

  // 模板编译完成
  mounted() {
    // 获取一览
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/cmsHomePage/contractRecordDirectlyList", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 服务器时间
          this.serverTime = data.serverTime.substring(0, 10);
          // 列表数据
          this.tableData = data.data.records;
          // 总条数
          this.total = data.data.total;
          // 关闭加载
          this.loading = false;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.val.id
      }
      // 跳转详情页面
      this.$router.push({
        path: "/contractRecordDirectlyDetailCms",
        query: obj,
      });

    },
    /**
     * 详情
     * @param e
     * @param controllerFlag
     */
    fun_Details(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.id
      }
      // 跳转详情页面
      this.$router.push({
        path: "/contractRecordDirectlyDetailCms",
        query: obj,
      });
    },
    /**
     * 跳转登录
     */
    fun_Login(e){
      // 如果是交易人
      if(e == "0"){
        // 跳转地址
        const route = this.$router.resolve({
          path: '/login',
        });
        window.open(route.href, '_blank');
      }
      // 如果是监管
      else{
        // 跳转地址
        const route = this.$router.resolve({
          path: '/workerLogin',
        });
        window.open(route.href, '_blank');
      }
    },
    /**
     * 下载中心
     */
    fun_DownloadCenter(){
      // 跳转地址
      const route = this.$router.resolve({
        path: '/cmsDownloadCenter',
      });
      window.open(route.href, '_blank');
    },
  }
};
